import { Rule } from 'antd/es/form';
import { Form, FormInstance } from 'antd/lib';
import React, { TextareaHTMLAttributes, useEffect } from 'react';
import getMessage from 'utilities/constants/MESSAGE';
import CommonTextArea from './CommonTextArea.component';

export interface TextAreaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
    name?: string;
    placeholder?: string;
    disabled?: any;
    maxLength?: number;
    required?: boolean;
    callback?: any;
    rules?: Rule[];
    label?: string;
    labelClassName?: string;
    onChange?: (value: any) => void;
    onResize?: (value: any) => void;
    onValidateError?: (isError: boolean) => void;
    size?: any;
    formatNumber?: boolean;
    resize?: boolean;
    currentForm?: FormInstance;
}

export const FormTextArea = ({
    rules = [],
    label,
    required,
    labelClassName = '',
    name,
    ...props
}: TextAreaProps) => {
    const [isRequire, setIsRequire] = React.useState<boolean>(required ?? false);
    const [itemRules, setItemRules] = React.useState<Rule[]>(rules);
    const checkRuleRequire = (rules: Rule[]) => {
        return rules.findIndex((rule: any) => {
            return rule.required;
        });
    };

    useEffect(() => {
        const ruleRequire: any = checkRuleRequire(rules);
        if (ruleRequire >= 0) {
            rules[ruleRequire] = {
                required: required,
                message: getMessage('In_Required', label),
            };
        } else {
            rules.push({
                required: required,
                message: getMessage('In_Required', label),
            });
        }
        setItemRules(rules);
        setIsRequire(ruleRequire >= 0 || (required ?? false));
    }, [required]);

    return (
        <>
            <span className={labelClassName}>
                {label}
                {label && isRequire && <span style={{ color: '#EB5757' }}>*</span>}
            </span>
            <Form.Item name={name} rules={itemRules} className={props.className}>
                <CommonTextArea name={name} rules={itemRules} {...props} />
            </Form.Item>
        </>
    );
};
